import { defineStore } from 'pinia';
import { api } from '@/services/http.service';
import {
  TagListItem,
  TagListPayload,
} from '@/models/dictionary/tag-list.model';
import { showErrorNotification } from '@/utils/show-notification.util';

interface TagListState {
  tagList: TagListItem[];
  isTagListLoading: boolean;
}

export const useTagListStore = defineStore('TagListStore', {
  state: (): TagListState => ({
    tagList: [],
    isTagListLoading: false,
  }),
  getters: {
    isTagListNotEmpty(state: TagListState): boolean {
      return state.tagList.length > 0;
    },
  },
  actions: {
    setTagListLoading(isLoading: boolean): void {
      this.isTagListLoading = isLoading;
    },
    setTagList(tagList: TagListItem[]): void {
      this.tagList = tagList;
    },
    getTagList({ object, filterList, isForceUpdate = false }: TagListPayload): Promise<TagListItem[]> {
      if (this.tagList.length && !isForceUpdate) {
        return Promise.resolve(this.tagList);
      }

      this.setTagListLoading(true);

      return api.dictionary.getTagListRequest.perform({
        object,
        filterList,
      })
        .then((tagList: TagListItem[]) => {
          this.tagList = tagList;

          return tagList;
        })
        .catch(error => {
          showErrorNotification(error);

          return [];
        })
        .finally(() => {
          this.setTagListLoading(false);
        });
    },
  },
});
